"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PracRoutes = void 0;
const base_1 = require("../base");
const constants_1 = require("../constants");
/**
 * API routes for practice list management
 * Handles user practice lists for speedrunning practice rooms and other lists
 */
class PracRoutes extends base_1.ApiBase {
    /**
     * Add an entry to a user's practice list
     * @param targetUser - The Twitch user ID whose practice list to modify
     * @param listName - The name of the practice list (e.g., "rooms")
     * @param entry - The entry text to add to the list
     * @returns Promise resolving when entry is added
     * @throws Error if the API request fails or service is not authenticated
     */
    async addPracticeListEntry(targetUser, listName, entry) {
        return this.apiPost(`${constants_1.ROUTES.PRAC}/${targetUser}/lists/${listName}/entries`, {
            entry,
        });
    }
    /**
     * Get all entries from a user's practice list
     * @param targetUser - The Twitch user ID whose practice list to retrieve
     * @param listName - The name of the practice list (e.g., "rooms")
     * @returns Promise resolving to practice list entries
     * @throws Error if the API request fails or practice list is not found
     */
    async getPracticeList(targetUser, listName) {
        return this.apiGet(`${constants_1.ROUTES.PRAC}/${targetUser}/lists/${listName}`);
    }
    /**
     * Delete a specific entry from a user's practice list by its index
     * @param targetUser - The Twitch user ID whose practice list to modify
     * @param listName - The name of the practice list (e.g., "rooms")
     * @param entryId - The 1-based index of the entry to delete
     * @returns Promise resolving when entry is deleted
     * @throws Error if the API request fails or entry is not found
     */
    async deletePracticeListEntry(targetUser, listName, entryId) {
        return this.apiDelete(`${constants_1.ROUTES.PRAC}/${targetUser}/lists/${listName}/entries/${entryId}`);
    }
    /**
     * Clear all entries from a user's practice list
     * @param targetUser - The Twitch user ID whose practice list to clear
     * @param listName - The name of the practice list (e.g., "rooms")
     * @returns Promise resolving when list is cleared
     * @throws Error if the API request fails or practice list is not found
     */
    async clearPracticeList(targetUser, listName) {
        return this.apiDelete(`${constants_1.ROUTES.PRAC}/${targetUser}/lists/${listName}`);
    }
}
exports.PracRoutes = PracRoutes;
//# sourceMappingURL=prac.js.map